<template>
    <div class="work-analyzer">
        <TabView :activeIndex.sync="selectedPivot" v-if="availablePanels.length !== 0">
            <TabPanel v-for="panel in availablePanels" :key="panel.id" :header="panel.name"></TabPanel>
        </TabView>
        <div class="mx-4 mb-2 d-flex justify-content-between">
            <div class="d-flex">
                <Button :label="$t('AppWorkAnalyzerFilter.Filtros')" icon="pi pi-filter" class="p-button-rounded p-button-outlined"
                        @click="openFilterDialog"/>
                <Button v-for="key in Object.keys(appliedFilters)" icon="pi pi-times" iconPos="right" :key="key"
                        :label="setFilterLabel(key)" v-tooltip.top="$t('AppWorkAnalyzerFilter.Remover filtro')"
                        @click="removeFilterFor(key)" class="p-button-rounded ml-2"/>
                <div v-for="d in drillInObjects" class="ml-3 d-flex align-items-center click" @click="selectDrillIn(d)">
                    <div class="mr-2">
                        <i class="pi pi-chevron-left"></i>
                    </div>
                    <div class="d-flex flex-column">
                        <div>
                            {{ $t(`AppWorkAnalyzerFilter.${d.key} (s)`) }}
                        </div>
                        <div>
                            {{ d.value.label }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="mr-4" v-if="operationType.name !== 'MOWING'">
                <SelectButton v-model="view" :options="viewOptions" optionLabel="name"/>
            </div>
        </div>

        <Dialog :visible.sync="showFilterDialog" :header="$t('AppWorkAnalyzerFilter.Filtrar')" modal
                :style="{width: '850px'}" :contentStyle="{'overflow': 'visible'}">
            <div class="row">
                <div class="col-4 mt-2" v-for="filter in filtersContent" :key="filter.id">
                    <div>
                        <div class="mt-2 mb-1">
                            {{ $t(`AppWorkAnalyzerFilter.${filter.id} (p)`) }}
                        </div>
                        <MultiSelect v-model="selectedFilterEdit[filter.id]" :options="filter.values" :dataKey="'id'"
                                     optionLabel="label" :placeholder="$t(`AppWorkAnalyzerFilter.${filter.id} (p)`)"
                                     :disabled="drillIn.includes(filter.id.toUpperCase()) || filter.values.length === 0"
                                     style="width: 250px"/>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="d-flex justify-content-between">
                    <div>
                        <Button :label="$t('AppWorkAnalyzerFilter.Limpar filtros')" icon="pi pi-filter-slash"
                                class="p-button-text" :disabled="allFiltersEmpty" @click="clearFilter"/>
                    </div>
                    <div>
                        <Button :label="$t('AppWorkAnalyzerFilter.Cancelar')" icon="pi pi-times" class="p-button-text"
                                :disabled="allFiltersEmpty" @click="closeDialog"/>
                        <Button :label="$t('AppWorkAnalyzerFilter.Filtrar')" icon="pi pi-check" class="p-button-text"
                                :disabled="allFiltersEmpty" @click="filterData"/>
                    </div>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>

import Button from "primevue/button";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import InputText from "primevue/inputtext";
import Dialog from "primevue/dialog";
import MultiSelect from "primevue/multiselect";
import SelectButton from "primevue/selectbutton";
import Tooltip from "primevue/tooltip";

export default {
    mounted() {
        this.setAvailablePanels();
        this.view = this.viewOptions[0];
    },
    data() {
        return {
            basePanels: [
                {
                    id: 0,
                    value: 'fields',
                    name: this.$t('AppWorkAnalyzerFilter.fields (s)')
                },
                {
                    id: 1,
                    value: 'operations',
                    name: this.$t('AppWorkAnalyzerFilter.operations (s)')
                },
                {
                    id: 2,
                    value: 'products',
                    name: this.$t('AppWorkAnalyzerFilter.products (s)')
                },
                {
                    id: 3,
                    value: 'varieties',
                    name: this.$t('AppWorkAnalyzerFilter.varieties (s)')
                },
                {
                    id: 4,
                    value: 'vehicles',
                    name: this.$t('AppWorkAnalyzerFilter.vehicles (s)')
                },
                {
                    id: 5,
                    value: 'operators',
                    name: this.$t('AppWorkAnalyzerFilter.operators (s)')
                }
            ],
            availablePanels: [],
            selectedPivot: 0,
            appliedFilters: {},
            showFilterDialog: false,
            selectedFilterEdit: {},
            selectedFilter: {},
            view: null,
            viewOptions: [
                {
                    name: this.$t('AppWorkAnalyzerFilter.Totais'),
                    code: 'totals'
                },
                {
                    name: this.$t('AppWorkAnalyzerFilter.Desempenho'),
                    code: 'performance'
                }
            ]
        }
    },
    methods: {
        setAvailablePanels() {
            let tmpPanels = JSON.parse(JSON.stringify(this.basePanels));

            if (this.operationType.name === 'TRANSPORT' || this.operationType.name === 'TILLAGE' || this.operationType.name === 'LIQUID_APPLICATION' || this.operationType.name === 'DRY_APPLICATION') {
                tmpPanels = tmpPanels.filter(panel => panel.value !== 'varieties');
            }

            if (this.operationType.name === 'TRANSPORT' || this.operationType.name === 'TILLAGE' || this.operationType.name === 'HARVEST' || this.operationType.name === 'MOWING' || this.operationType.name === 'SEEDING') {
                tmpPanels = tmpPanels.filter(panel => panel.value !== 'products');
            }

            this.drillInObjects.forEach(d => {
                tmpPanels = tmpPanels.filter(panel => panel.value !== d.key);
            })

            this.availablePanels = JSON.parse(JSON.stringify(tmpPanels));
            this.parseQueryPivot();
        },
        parseQueryPivot() {
            if (!this.queryPivot) {
                this.selectedPivot = 0;
            }

            let pos = this.availablePanels.findIndex(p => p.value === this.queryPivot);

            if (pos === -1) {
                pos = 0;
            }

            if (pos === this.selectedPivot) {
                return;
            }

            this.selectedPivot = pos;
        },
        openFilterDialog() {
            this.selectedFilterEdit = JSON.parse(JSON.stringify(this.selectedFilter));
            this.showFilterDialog = true;
        },
        filterData() {
            this.selectedFilter = JSON.parse(JSON.stringify(this.selectedFilterEdit));
            let tmpFilter = {}
            for (const filter of Object.keys(this.selectedFilter)) {
                if (this.selectedFilter[filter].length > 0) {
                    tmpFilter[filter] = []
                    this.selectedFilter[filter].forEach((value) => {
                        tmpFilter[filter].push(value.id)
                    })
                }
            }

            this.appliedFilters = tmpFilter;
            this.closeDialog();
        },
        closeDialog() {
            this.showFilterDialog = false;
        },
        clearFilter() {
            this.selectedFilter = {};
            this.appliedFilters = {};
            this.closeDialog();
        },
        clearSelections(clearFilters = true) {
            if (clearFilters) {
                if (Object.keys(this.appliedFilters).length > 0 && Object.keys(this.selectedFilter).length > 0) {
                    this.clearFilter();
                }
            }
            while (this.availablePanels.length > 0) {
                this.availablePanels.pop()
            }
        },
        selectDrillIn(d) {
            this.$emit('removeDrillUpTo', d.key.toUpperCase())
        },
        setFilterLabel(key) {
            if (this.appliedFilters[key].length === 1) {
                let filterObject = this.filtersContent.find(filter => filter.id === key)
                let selectedObject = filterObject.values.find(obj => obj.id === this.appliedFilters[key][0])
                return selectedObject.label === 'UNKNOWN' ? this.$t(`AppWorkAnalyzerTable.UNKNOWN`) : selectedObject.label
            }

            return this.appliedFilters[key].length + ' ' + this.$t(`AppWorkAnalyzerFilter.${key} (p)`)
        },
        removeFilterFor(key) {
            delete this.selectedFilterEdit[key]
            this.filterData();
        },
        parseLabel() {
            this.filtersContent.forEach(filter => {
                filter.values.forEach((value) => {
                    value.label = value.label === 'UNKNOWN' ? this.$t('AppWorkAnalyzerTable.UNKNOWN') : value.label
                })
            })
        }
    },
    props: {
        drillIn: {
            type: String
        },
        operationType: {
            type: Object
        },
        filtersContent: {
            type: Array
        },
        allFiltersEmpty: {
            type: Boolean,
            default: false
        },
        queryPivot: {
            type: String
        }
    },
    watch: {
        drillIn: function () {
            this.clearSelections(false);
            setTimeout(() => {this.setAvailablePanels()}, 5);
        },
        pivotLabel: function () {
            if (!this.pivotLabel || !this.filtersContent) {
                return;
            }

            this.$emit('pivotSelected', this.pivotLabel.value);
        },
        appliedFilters: function () {
            this.$emit('filterData', JSON.parse(JSON.stringify(this.appliedFilters)));
        },
        filtersContent: function () {
            this.parseLabel();
            this.clearSelections();
            setTimeout(() => {this.setAvailablePanels()}, 5);
        },
        view: function () {
            this.$emit('updateTableView', this.view);
        }
    },
    computed: {
        pivotLabel: function () {
            return this.availablePanels[this.selectedPivot];
        },
        drillInObjects: function () {
            if (!this.drillIn || !this.filtersContent) {
                return [];
            }

            let drilledInObjects = [];
            let drill = this.drillIn.split(';');
            drill.forEach(key_value => {
                let k_v = key_value.split(":");
                let key = k_v[0].toLowerCase();
                let filterObjects = this.filtersContent.find(filter => filter.id === key).values;
                let value = filterObjects.find(obj => obj.id === k_v[1].toLowerCase());

                drilledInObjects.push({key: key, value: value});
            })
            return drilledInObjects;
        }
    },
    directives: {
        'tooltip': Tooltip
    },
    components: {MultiSelect, Dialog, InputText, Button, TabView, TabPanel, SelectButton, Tooltip}
}
</script>

<style scoped>
.click {
    cursor: pointer;
}
</style>
